import {
  Atom, Award, BatteryCharging, BrainCircuit, BriefcaseBusiness, Cable, Calculator, ClipboardList, Code2, Cpu, DraftingCompass,
  Gauge, GraduationCap, Handshake, HardHat, LandPlot, Leaf, Megaphone, Network, Scale, Server, ShieldCheck, SlidersHorizontal, Snowflake,
  Truck, Users, Wrench, Zap,
} from "lucide-react";

const CATEGORY_STYLE = {
  "Data center operations": { color: "#B45309", bg: "#FEF3C7", Icon: Server },
  "Facilities & power": { color: "#B91C1C", bg: "#FEE2E2", Icon: Zap },
  "Energy & sustainability": { color: "#15803D", bg: "#DCFCE7", Icon: BatteryCharging },
  "Construction & commissioning": { color: "#C2410C", bg: "#FFEDD5", Icon: HardHat },
  "Network & fiber": { color: "#0369A1", bg: "#E0F2FE", Icon: Cable },
  "Cloud & compute": { color: "#4338CA", bg: "#E0E7FF", Icon: Cpu },
  "Real estate & site development": { color: "#7C2D12", bg: "#FCE7D6", Icon: LandPlot },
  "Supply chain & logistics": { color: "#0F766E", bg: "#CCFBF1", Icon: Truck },
  "Security & safety": { color: "#BE123C", bg: "#FFE4E6", Icon: ShieldCheck },
  "Commercial & corporate": { color: "#047857", bg: "#D1FAE5", Icon: BriefcaseBusiness },
};

const TITLE_ICONS = [
  [/\b(intern|internship|apprentice|graduate|new grad|early talent)\b/i, GraduationCap, "Early career role"],
  [/\b(director|vp|vice president|head of|chief)\b/i, Award, "Leadership role"],
  [/\b(nuclear|reactor|fission|fusion)\b/i, Atom, "Nuclear energy"],
  [/\b(sustainability|environmental|esg|carbon)\b/i, Leaf, "Sustainability"],
  [/\b(site selection|land|real estate|entitlement|permitting|zoning|leasing)\b/i, LandPlot, "Site & real estate"],
  [/\b(security|compliance|grc|trust|safety|ehs|hse)\b/i, ShieldCheck, "Security & safety"],
  [/\b(electrical|electrician|power|energy|utility|grid|substation|generator|ups)\b/i, Zap, "Power & electrical"],
  [/\b(mechanical|cooling|hvac|thermal|chiller|liquid)\b/i, Snowflake, "Mechanical & cooling"],
  [/\b(battery|storage|bess|solar|renewable)\b/i, BatteryCharging, "Energy storage"],
  [/\b(fiber|fibre|cabling|cable|splic)\b/i, Cable, "Fiber & cabling"],
  [/\b(network|networking|noc|fabric|interconnect)\b/i, Network, "Networking"],
  [/\b(gpu|hpc|ai|ml|machine learning|inference|training|cuda)\b/i, BrainCircuit, "AI & GPU systems"],
  [/\b(sre|reliability|observability|incident)\b/i, Gauge, "Reliability"],
  [/\b(software|developer|backend|frontend|full[- ]stack|platform engineer|devops)\b/i, Code2, "Software"],
  [/\b(construction|commissioning|superintendent|field engineer|site development|preconstruction)\b/i, HardHat, "Construction"],
  [/\b(controls|bms|automation|instrumentation)\b/i, SlidersHorizontal, "Controls"],
  [/\b(architect|design|designer|drafter|cad|bim)\b/i, DraftingCompass, "Design"],
  [/\b(technician|hardware|rack|field service|maintenance|electrician|installer)\b/i, Wrench, "Hands-on technical"],
  [/\b(sales|account|business development|partnership|customer success|revenue|go-to-market|gtm)\b/i, Handshake, "Sales & partnerships"],
  [/\b(marketing|brand|communications|content|events)\b/i, Megaphone, "Marketing"],
  [/\b(finance|financial|accountant|accounting|analyst|treasury|fp&a|tax|investment)\b/i, Calculator, "Finance & analysis"],
  [/\b(legal|counsel|paralegal|contracts?)\b/i, Scale, "Legal"],
  [/\b(recruit|talent|people|human resources|hr|culture)\b/i, Users, "People & talent"],
  [/\b(procurement|sourcing|supply chain|logistics|warehouse)\b/i, Truck, "Supply chain"],
  [/\b(project manager|program manager|project engineer|scheduler|planner|pmo)\b/i, ClipboardList, "Project delivery"],
];

export const jobIconFor = (job) => {
  const style = CATEGORY_STYLE[job.category] || { color: "#3C4450", bg: "#F0F2F4", Icon: BriefcaseBusiness };
  const match = TITLE_ICONS.find(([pattern]) => pattern.test(job.title));
  return { Icon: match ? match[1] : style.Icon, label: match ? match[2] : job.category, color: style.color, bg: style.bg };
};

export const JobIcon = ({ job, size = 16, testId }) => {
  const { Icon, label, color, bg } = jobIconFor(job);
  const box = size + 16;
  return (
    <span data-testid={testId} title={label} aria-label={label} role="img" className="shrink-0 inline-flex items-center justify-center rounded-full" style={{ width: box, height: box, background: bg, color }}>
      <Icon size={size} aria-hidden="true" strokeWidth={2.2} />
    </span>
  );
};
